import { render, staticRenderFns } from "./ursLogin.vue?vue&type=template&id=ee22b73a&scoped=true"
import script from "./ursLogin.vue?vue&type=script&lang=js"
export * from "./ursLogin.vue?vue&type=script&lang=js"
import style0 from "./ursLogin.vue?vue&type=style&index=0&id=ee22b73a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee22b73a",
  null
  
)

export default component.exports